<template>
  <div class="uploadimg"
       @dragleave="dragleave">
    <div v-if="imageUrl"
      class="bg-center bg-cover"
      :style="{
        position: 'relative',
        width: '280px',
        height: '187px',
        'background-image': `url(${image})`,
        'background-size': 'contain',
      }"
    >
      <button
        class="btn square absolute"
        style="position: absolute; top: 10px; right: 10px;"
      >
        <v-icon @click="setUrl(null)">delete</v-icon>
      </button>
    </div>
    <div :class="{
           'uploadimg-body': !isDrag && isMatch,
           'uploadimg-body-drag': isDrag && isMatch,
           'uploadimg-body-fail': !isMatch,
         }"
         ref="select_frame"
         v-show="!imageUrl"
         @drop="onChange"
         @dragenter="dragenter"
         @dragover.prevent>
      <div v-if="!isDrag && isMatch">
        <div>
          <span class="material-icons" draggable="true">
            image__rounded
          </span>
        </div>
        <input type="file" id="file" ref="image_upload" @change="onChange" hidden>
        <button class="btn" @click="chooseFiles">上傳圖片</button>
        <div class="h5">或將圖片拖曳至此</div>
      </div>
      <div v-if="isDrag && isMatch">
        <div>
          <span class="material-icons" draggable="true">
            cloud_upload__rounded
          </span>
        </div>
        <div class="h5">Drop files to upload</div>
      </div>
      <div v-if="!isMatch">
        <div>
          <span class="material-icons" draggable="true">
            error__rounded
          </span>
        </div>
        <div class="h5">檔案格式不符合</div>
        <div class="h5">( 請上傳.png / .jpg / .gif)</div>
      </div>
    </div>
    <div class="d-flex" style="margin-top: 10px">
      <button class="btn flex-grow-1" @click="isGallaryOpen = true">
        從圖庫選擇圖片
      </button>
    </div>
    <MaterialGalleryCreater
      :isOpen="isGallaryOpen"
      @gallary-close="isGallaryOpen = false"
      @setUrl="setUrl"
    ></MaterialGalleryCreater>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MaterialGalleryCreater from '@/components/C-1-1-1__Category-Create_UploadImage-From-MaterialGallery.vue';

export default {
  props: [
    'imageUrl',
    'dir',
  ],
  components: {
    MaterialGalleryCreater,
  },
  data: () => ({
    isDrag: false,
    isMatch: true,
    infoshow: false,
    fileList: [],
    isGallaryOpen: false,
  }),
  computed: {
    image() {
      if (this.imageUrl && this.imageUrl.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${this.imageUrl}`;
      }

      return this.imageUrl;
    },
  },
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    dragleave(e) {
      e.preventDefault();
      this.isDrag = false;
      this.isMatch = true;
    },
    onChange(e) {
      e.preventDefault();
      const data = e.target.files || e.dataTransfer.files;
      if (!data.length) {
        this.isDrag = false;
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].type.indexOf('image') === -1) {
          this.setFailFileTips();
          return;
        }
      }
      this.handleFileUpload(data);
    },
    dragenter(e) {
      e.preventDefault();
      this.isDrag = true;
    },
    handleFileUpload(data) {
      const formData = new FormData();
      formData.append('dir', this.dir);
      for (let i = 0; i < data.length; i += 1) {
        formData.append('file', data[i], data[i].name);
      }
      this.upload(formData).then((res) => {
        this.setUrl(res.url);
      });
    },
    setFailFileTips() {
      this.isMatch = false;
      setTimeout(() => {
        this.isMatch = true;
        this.isDrag = false;
      }, 1500);
    },
    chooseFiles() {
      this.$refs.image_upload.click();
    },
    setUrl(url) {
      this.$emit('update:imageUrl', url);
    },
  },
};
</script>

<style lang="scss">
.uploadimg {
  width: 280px;

  &-body {
    height: 216px;
    border: 1px dashed #848fa0;
    text-align: center;
    border-radius: 4px;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #848fa0;
    }

    .btn {
      margin-top: 9px;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-drag {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #194cc3;
    background-color: #e8efff;
    color: #1e50c0;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #1e50c0;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-fail {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #f90000;
    background-color: #ffe7e7;
    color: #ff0000;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #ff0000;
    }

    div {
      margin-top: 10px;
    }
  }
}
</style>
